<script setup>

	const url = useRequestURL()

	const { data: page } = await useAPIFetch('ForArtists')
	const deals = page.value.body.find(item => item.specific === 'Deals')
	const dealCategories = page.value.body.filter(item => item.component === 'DealItemList')
	const distributionCategory = page.value.body.find(item => item.specific === 'Distribution')
	const recordDealCategory = page.value.body.find(item => item.specific === 'RecordDeal')
	const exclusiveDealCategory = page.value.body.find(item => item.specific === 'ExclusiveDeal')
	const sendMusic = page.value.body.find(item => item.specific === 'SendMusic')
	const sendMusicBtns = sendMusic?.buttons?.items

	useHeadData({
		title: page.value.meta.title,
		description: page.value.meta.description,
		author: page.value.meta.author,
		copyright: page.value.meta.copyright,
		keywords: page.value.meta.keywords,
		og: page.value.meta.og,
		url: url.href
	})

</script>

<template>
	<div class="container">
		<h1 class="text-gold text-center mb-8 lg:mb-10">{{ page.attrs.title }}</h1>
		<div class="max-w-[865px] mx-auto xl:text-center">
			<WysiwygPerex :value="page.attrs.perex" />
		</div>

		<div class="xl:grid grid-cols-12 gap-8">
			<div class="col-span-10 col-start-2">
				<RecordCategories v-if="deals" :distributionCategory="distributionCategory" :recordDealCategory="recordDealCategory" :exclusiveDealCategory="exclusiveDealCategory" />

				<div v-if="dealCategories">
					<RecordCategory
						v-for="(category, index) in dealCategories"
						:key="category.id"
						:title="category.title"
						:box="category.box"
						:box-image="index % 2 === 0 ? 'left' : 'right'"
						:levels="category.levels"
						:items="category.items"
						:specific="category.specific"
						:perex="category.perex"
					/>
				</div>
			</div>
		</div>
	
		<div class="xl:grid grid-cols-12 gap-8">
			<div class="col-span-8 col-start-3">
				<div v-if="sendMusic">
					<h2 class="h1 text-gold mb-10 xl:text-center">{{ sendMusic.title }}</h2>
					<WysiwygPerex class="mb-10 xl:mb-20 max-w-[644px] xl:text-center xl:mx-auto" :value="sendMusic.perex" />
					<WysiwygText class="mb-10 xl:mb-20" :value="sendMusic.content" />
					
					<div v-if="sendMusicBtns" class="xl:text-center mb-20">
						<Button type="gold" v-for="(item, index) in sendMusicBtns" :key="index" :to="item.href" class="mb-2" :class="[index == sendMusicBtns.length - 1 ? '' : 'mr-2 lg:mr-4']" target>{{ item.label }}</Button>
					</div>
				</div>
			</div>
		</div>
	
	</div>
</template>